module.exports = __webpack_public_path__ + "img/x18.800b90f4.jpg";